export default {
	install(Vue, { sectionName = '카페탑', pageName = '인기글뷰' } = {}) {
		const prefix = `${sectionName}_${pageName}`;

		const isDefined = () => typeof TiaraTracker !== 'undefined';

		const generateProps = (custom = {}) => {
			return {...custom}
		};

		Vue.prototype.$trackEvent = ({ layer, layerName, clickUrl, customProps, eventMeta, actionKind }) => {
			if (!isDefined()) return;
			const { layer1='' } = layer;

			var clickObj = {
				layer1: layer1,
				copy: '',
				posx: 0,
				posy: 0
			};

			if (clickUrl) {
				clickObj.click_url = clickUrl.slice(0, 255);
			}
			const tracker = TiaraTracker.getInstance()
				.trackEvent(`${prefix}_${layerName}`)
				.click(clickObj)
				if(actionKind)
					tracker.actionKind(actionKind)
				if(customProps)
					tracker.customProps(generateProps(customProps))
				if(eventMeta)
					tracker.eventMeta(eventMeta)

				tracker.track();
		};

		Vue.prototype.$trackViewImp = ({ page, layerName, contents, customProps = {} }) => {
			if (!isDefined() || !contents.length) return;
			TiaraTracker.getInstance()
				.setSection('user_action')
				.setPage(page)
				.trackViewImp(`${prefix}_${layerName}`)
				.viewImpContents(contents)
				.customProps(generateProps(customProps))
				.track();
		};
	}
}
